<div class="Loading-wrapper">
  <div id="loadingOverlay" *ngIf="isConnecting">
    <div class="md-loadingRect">
      <div class="md-loadingRectChild md-loadingRect1"></div>
      <div class="md-loadingRectChild md-loadingRect2"></div>
      <div class="md-loadingRectChild md-loadingRect3"></div>
      <div class="md-loadingRectChild md-loadingRect4"></div>
      <div class="md-loadingRectChild md-loadingRect5"></div>
      <div class="md-loading-text">CONNECTING</div>
    </div>
  </div>
</div>

<div class="col-lg-6 col-md-8 col-sm-10 col-lg-offset-3 col-md-offset-2 col-sm-offset-1 push-down-50">
  <div class="panel-auth" *ngIf="!isConnecting">
    <div class="auth-header">
      <div class="comms-logo-wrap">
        <img src="/images/logo-comms.png">
      </div>
    </div>

    <div class="col-sm-10 col-sm-offset-1 push-down-50" *ngIf="status != null">
      <div class="login-message">
        <p>
          {{statusMessage}}
        </p>
      </div>
    </div>

    <div class="clear"></div>

    <div>
      <div class="col-sm-10 col-sm-offset-1 push-down-30">
        <div class="form-elem">
          <div class="form-elem-name">Session ID</div>
          <div class="form-elem-field">
            <input type="text" [(ngModel)]="model.sessionId">
          </div>
        </div>
      </div>

      <div class="clear"></div>

      <div class="col-sm-10 col-sm-offset-1 push-down-5">
        <div class="form-elem">
          <div class="form-elem-name">Session PIN</div>
          <div class="form-elem-field">
            <input type="text" [(ngModel)]="model.pin">
          </div>
        </div>
      </div>

      <div class="clear"></div>

      <div class="col-sm-10 col-sm-offset-1 push-down-15 push-up-35">
        <button class="btn-main-proceed-alt" (click)="sessionStartClick()">JOIN SESSION</button>
      </div>
    </div>
  </div>
</div>

<div class="clear"></div>
